import { createRouter, createWebHistory } from "vue-router";
import ICON3 from "@/assets/menu/library.png";
import ICON5 from "@/assets/menu/ST.png";
import ICON6 from "@/assets/menu/ydlj.png";

import IdeaSpark from "@/assets/menu/IdeaSpark.png";
import IdeaChallenge from "@/assets/menu/IdeaChallenge.png";
import IdeaTalk from "@/assets/menu/IdeaTalk.png";
import IdeaMeet from "@/assets/menu/IdeaMeet.png";
import IdeaExplore from "@/assets/menu/IdeaExplore.png";
import IdeaActivity from "@/assets/menu/IdeaActivity.png";
import IdeaReport from "@/assets/menu/IdeaReport.png";
import IdeaWork from "@/assets/menu/IdeaWork.png";
import ClassManagement from "@/assets/menu/class.png";
import Oldlibrary from "@/assets/menu/old-courseware-icon-44.png";

export const routes: any = [
  {
    name: "index",
    path: "/",
    redirect: () => {
      const loginType = localStorage.getItem("loginType") || "teacher";
      return loginType === "student"
        ? "/student-work"
        : loginType === "institutions"
        ? "/institutions"
        : "/exam";
    },
    components: {
      default: () => import("@vs/Index/Index.vue"),
      header: () => import("@cs/TopHeader/Main-Header.vue"),
      sidebar: () => import("@cs/Assign-Menu/Assign-Menu.vue")
    },
    children: [
      // {
      //   name: "Talk",
      //   path: "talk",
      //   auth: ["home"],
      //   components: {
      //     default: () => import("@vs/Idea-Talk/Home-Page.vue")
      //   },
      //   menu: "menu.system_settings.ideaTalk",
      //   role: ["ROLE_EDITOR", "ROLE_TEACHER", "ROLE_ORG_TEACHER"],
      //   icon: IdeaTalk,
      //   isMenu: true,
      //   active: "talk"
      // },
      {
        name: "Meet",
        path: "meet",
        auth: ["home"],
        components: {
          default: () => import("@vs/Idea-Meet/Home-Page.vue")
        },
        menu: "menu.system_settings.ideaMeet",
        role: ["ROLE_EDITOR", "ROLE_TEACHER", "ROLE_ORG_TEACHER"],
        icon: IdeaMeet,
        isMenu: true,
        active: "meet"
      },
      {
        name: "Exam",
        path: "exam",
        auth: ["home"],
        components: {
          default: () => import("@vs/Exam/Home-Page.vue")
        },
        menu: "menu.system_settings.ideaMeet",
        role: ["ROLE_EDITOR", "ROLE_TEACHER", "ROLE_ORG_TEACHER"],
        icon: IdeaMeet,
        isMenu: true,
        active: "exam"
      },
      // {
      //   name: "Spark",
      //   path: "spark",
      //   auth: ["home"],
      //   components: {
      //     default: () => import("@vs/Idea-Spark/Home-Page.vue")
      //   },
      //   menu: "menu.system_settings.ideaSpark",
      //   role: ["ROLE_EDITOR", "ROLE_TEACHER", "ROLE_ORG_TEACHER"],
      //   icon: IdeaSpark,
      //   isMenu: true,
      //   active: "spark"
      // },
      {
        name: "Explore",
        path: "explore",
        auth: ["home"],
        components: {
          default: () => import("@vs/Idea-Explore/Home-Page.vue")
        },
        menu: "menu.system_settings.ideaExplore",
        role: ["ROLE_EDITOR", "ROLE_TEACHER", "ROLE_ORG_TEACHER"],
        icon: IdeaExplore,
        isMenu: true,
        active: "explore"
      },
      {
        name: "Challenge",
        path: "challenge",
        auth: ["home"],
        components: {
          default: () => import("@vs/Idea-Challenge/Home-Page.vue")
        },
        menu: "menu.system_settings.ideaChallenge",
        role: ["ROLE_EDITOR", "ROLE_TEACHER", "ROLE_ORG_TEACHER"],
        icon: IdeaChallenge,
        isMenu: true,
        active: "challenge"
      },
      {
        name: "ActivityList",
        path: "/activities",
        components: {
          default: () => import("@vs/ActivityList/ActivityList.vue")
        },
        icon: "",
        isMenu: false,
        active: "talk"
      },
      {
        name: "Activity-page",
        path: "activities-page",
        auth: ["home"],
        components: {
          default: () => import("@vs/Idea-Activity/Activity-View.vue")
        },
        menu: "menu.system_settings.ideaActivity",
        role: ["ROLE_EDITOR", "ROLE_TEACHER", "ROLE_ORG_TEACHER"],
        icon: IdeaActivity,
        isMenu: true,
        active: "activities-page"
      },
      {
        name: "work",
        path: "work",
        auth: ["home"],
        components: {
          default: () => import("@vs/Idea-Work/Home-Page.vue")
        },
        menu: "menu.system_settings.ideaWork",
        role: ["ROLE_EDITOR", "ROLE_TEACHER", "ROLE_ORG_TEACHER"],
        icon: IdeaWork,
        isMenu: true,
        active: "work"
      },
      // {
      //   name: "Report",
      //   path: "report",
      //   auth: ["home"],
      //   components: {
      //     default: () => import("@vs/Idea-Report/Report.vue")
      //   },
      //   menu: "menu.system_settings.report",
      //   role: ["ROLE_EDITOR", "ROLE_TEACHER", "ROLE_ORG_TEACHER"],
      //   icon: IdeaReport,
      //   isMenu: true,
      //   active: "report"
      // },
      {
        name: "reportDetail",
        path: "/report-detail",
        auth: ["home"],
        components: {
          default: () => import("@vs/Idea-Report/Detail.vue")
        },
        menu: "menu.system_settings.report",
        role: ["ROLE_EDITOR", "ROLE_TEACHER", "ROLE_ORG_TEACHER"],
        icon: IdeaReport,
        isMenu: false,
        active: "report"
      },
      {
        name: "student-work",
        path: "student-work",
        auth: ["home"],
        components: {
          default: () => import("@vs/Student/Idea-Work/Home-Page.vue")
        },
        menu: "menu.system_settings.ideaWork",
        role: ["ROLE_STUDENT"],
        icon: IdeaWork,
        isMenu: true,
        active: "work"
      },
      {
        name: "student-report",
        path: "student-report",
        auth: ["home"],
        components: {
          default: () => import("@vs/Student/Idea-Report/Report.vue")
        },
        menu: "menu.system_settings.report",
        role: ["ROLE_STUDENT"],
        icon: IdeaReport,
        isMenu: true,
        active: "report"
      },
      // {
      //   name: "PPT-First-Step",
      //   path: "/slide-create",
      //   components: {
      //     default: () => import("@vs/Slide-Create/PPT-First-Step/PPT-First-Step.vue")
      //   },
      //   children: [],
      //   menu: "menu.system_settings.createCourse",
      //   role: ["ROLE_EDITOR", "ROLE_TEACHER"],
      //   icon: '',
      //   isMenu: true,
      //   active:'slide-create'
      // },
      {
        name: "outline",
        path: "/outline",
        components: {
          default: () => import("@vs/Idea-Spark/Outline/Outline.vue")
        },
        role: ["ROLE_EDITOR", "ROLE_TEACHER", "ROLE_ORG_TEACHER"],
        icon: "",
        isMenu: false,
        active: "spark"
      },
      {
        name: "ppt-second-step",
        path: "/second-step",
        components: {
          default: () => import("@vs/Slide-Create/PPT-Second-Step/PPT-Second-Step.vue")
        },
        role: ["ROLE_EDITOR", "ROLE_TEACHER", "ROLE_ORG_TEACHER"],
        icon: "",
        isMenu: false,
        active: "slide-create"
      },
      {
        name: "class-management",
        path: "/class-management",
        auth: ["home"],
        components: {
          default: () => import("@vs/Class-Management/Index.vue")
        },
        menu: "menu.system_settings.class_management",
        role: ["ROLE_EDITOR", "ROLE_TEACHER"],
        icon: ClassManagement,
        isMenu: true,
        active: "class-management",
        isbotMenu: true
      },
      {
        name: "recharge-page",
        path: "/recharge",
        auth: ["any"],
        components: {
          default: () => import("@vs/Subscribe/Recharge-Page.vue")
        },
        role: ["ROLE_EDITOR", "ROLE_TEACHER"],
        menu: "menu.system_settings.recharge_center",
        icon: ICON3,
        isMenu: true,
        active: "recharge",
        isbotMenu: true
      },
      {
        name: "recharge-page-org",
        path: "/recharge-org",
        auth: ["any"],
        components: {
          default: () => import("@vs/Subscribe/Recharge-Page-Org.vue")
        },
        role: ["ROLE_ORG_TEACHER"],
        menu: "menu.system_settings.recharge_center",
        icon: ICON3,
        isMenu: true,
        active: "recharge-org",
        isbotMenu: true
      },
      {
        name: "ai-setting",
        path: "/ai-setting",
        auth: ["home"],
        components: {
          default: () => import("@vs/Login/Password/Modify-Password.vue")
        },
        menu: "menu.system_settings.setting",
        role: ["ROLE_EDITOR", "ROLE_TEACHER", "ROLE_STUDENT", "ROLE_ORG_TEACHER"],
        icon: ICON5,
        isMenu: true,
        active: "ai-setting",
        isbotMenu: true
      },
      {
        name: "help",
        path: "/help",
        auth: ["any"],
        components: {
          default: () => import("@vs/Help/Help-Page.vue")
        },
        role: ["ROLE_EDITOR", "ROLE_TEACHER", "ROLE_STUDENT", "ROLE_ORG_TEACHER"],
        menu: "menu.system_settings.help",
        icon: ICON6,
        isMenu: true,
        active: "help",
        isbotMenu: true
      }
      // {
      //   name: "library",
      //   path: "library",
      //   auth: ["home"],
      //   components: {
      //     default: () => import("@vs/Spark/Home-Page/Home-Page.vue")
      //   },
      //   menu: "menu.system_settings.library",
      //   role: ["ROLE_EDITOR"],
      //   icon: Oldlibrary,
      //   isMenu: true,
      //   active: "library",
      //   isbotMenu: true
      // }
    ]
  },
  {
    name: "login",
    path: "/login",
    auth: ["any"],
    children: [],
    menu: "登录",
    // redirect?: string
    component: () => import("@vs/Login/Login/Login-View-Main.vue")
  },
  {
    name: "recharge-ad",
    auth: ["any"],
    menu: "订阅",
    path: "/recharge-ad",
    component: () => import("@vs/Login/Recharge-Ad/Recharge-Ad.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    auth: ["any"],
    children: [],
    menu: "注册",
    component: () => import("@vs/Login/Sign-up/Sign-Up.vue")
  },
  {
    name: "forgot-password",
    auth: ["any"],
    path: "/forget-password",
    component: () => import("@vs/Login/Forget-Password/Forget-Password.vue"),
    role: ["any"],
    menu: "忘记密码"
  },
  {
    path: "/question-generation",
    name: "question-generation",
    component: () => import("@vs/Question-Generation/Question-Generation-Main.vue"),
    auth: ["any"],
    menu: ""
  },
  {
    name: "Institutional management",
    path: "/institutional-management",
    auth: ["institutional"],
    components: {
      default: () => import("@vs/Class-Management/Index.vue")
    },
    menu: "menu.system_settings.class_management",
    role: ["ROLE_INSTITUTIONAL"],
    icon: ClassManagement,
    isMenu: true,
    active: "institutional-management"
  },
  {
    path: "/403",
    name: "403",
    component: () => import("@vs/403/Permission-Denied.vue"),
    auth: ["any"],
    menu: "无权限"
  },
  {
    name: "not-found",
    auth: ["any"],
    path: "/:pathMatch(.*)*",
    component: () => import("@vs/404/Not-Found.vue"),
    menu: "未找到页面"
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
